import { E_AUTH_ACTION_TYPES } from './actionTypes';
import { actionCreator } from '../helpers/actionCreator';
export var authActions = {
    loginSucceeded: function (payload) { return actionCreator(E_AUTH_ACTION_TYPES.USER_LOGIN_SUCCEEDED, payload); },
    logoutRequested: function () { return actionCreator(E_AUTH_ACTION_TYPES.USER_LOGOUT_REQUESTED); },
    logoutSucceeded: function () { return actionCreator(E_AUTH_ACTION_TYPES.USER_LOGOUT_SUCCEEDED); },
    fetchPermissionsRequested: function () { return actionCreator(E_AUTH_ACTION_TYPES.FETCH_PERMISSIONS_REQUESTED); },
    fetchPermissionsSucceeded: function (permissions) {
        return actionCreator(E_AUTH_ACTION_TYPES.FETCH_PERMISSIONS_SUCCEEDED, { permissions: permissions });
    },
    fetchGroupsRequested: function () { return actionCreator(E_AUTH_ACTION_TYPES.FETCH_GROUP_REQUESTED); },
    fetchGroupsSucceeded: function (groups) { return actionCreator(E_AUTH_ACTION_TYPES.FETCH_GROUP_SUCCEEDED, { groups: groups }); },
};
